import { library } from "@fortawesome/fontawesome-svg-core";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import * as React from "react";

library.add(faTimes);

export const ConfirmDialog = (props: {
    callBack: (value) => void,
    cancelText?: string,
    isOpen: boolean,
    message: string,
    okText?: string,
}) => {
    return props.isOpen ? <Dialog title={"Please confirm"} onClose={async () => await props.callBack(false)}>
        <p style={{ margin: "25px", textAlign: "center" }}>{props.message}</p>
        <DialogActionsBar>
            <button
                className="k-button"
                onClick={async (e) => {
                    e.preventDefault();
                    await props.callBack(false);
                }}
            >
                {props.cancelText || "Cancel"}
            </button>
            <button
                className="k-button"
                onClick={async (e) => {
                    e.preventDefault();
                    await props.callBack(true);
                }}
            >
                {props.okText || "OK"}
            </button>
        </DialogActionsBar>
    </Dialog> : null;
};

export const AlertDialog = (props: {
    callBack?: (value) => void,
    isOpen: boolean,
    message: string,
    okText?: string,
}) => {
    return props.isOpen ?
        <Dialog
            title={"Alert"}
            onClose={async () => {
                if (props.callBack) {
                    await props.callBack(true);
                }
            }}
        >
            <p style={{ margin: "25px", textAlign: "center" }}>{props.message}</p>
            <DialogActionsBar>
                <button
                    className="k-button"
                    onClick={async (e) => {
                        e.preventDefault();
                        if (props.callBack) {
                            await props.callBack(true);
                        }
                    }}
                >
                    {props.okText || "OK"}
                </button>
            </DialogActionsBar>
        </Dialog> : null;
};
